module.exports = __webpack_public_path__ + "static/media/06.98a607b6.jpg";